/**
 * FeedbackButtons — Thumbs up / down for semantic query results.
 * Uses message_id from the response for feedback submission.
 */
import React, { useState } from 'react'

export function FeedbackButtons({ messageId, onSubmit }) {
  const [submitted, setSubmitted] = useState(null) // 'up' | 'down' | null
  const [showComment, setShowComment] = useState(false)
  const [comment, setComment] = useState('')
  const [loading, setLoading] = useState(false)

  if (!messageId) return null

  async function handleFeedback(type) {
    if (submitted) return
    if (type === -1) {
      setShowComment(true)
      return
    }
    setLoading(true)
    const success = await onSubmit(messageId, type, '')
    setLoading(false)
    if (success) setSubmitted('up')
  }

  async function handleDownvoteSubmit() {
    setLoading(true)
    const success = await onSubmit(messageId, -1, comment)
    setLoading(false)
    if (success) {
      setSubmitted('down')
      setShowComment(false)
    }
  }

  if (submitted) {
    return (
      <div className="inline-flex items-center gap-1.5 rounded-full bg-slate-50 px-2.5 py-1 text-xs text-slate-500">
        {submitted === 'up' ? '👍' : '👎'} Feedback submitted
      </div>
    )
  }

  return (
    <div className="inline-flex flex-col gap-2">
      <div className="inline-flex items-center gap-1">
        <button
          onClick={() => handleFeedback(1)}
          disabled={loading}
          className="rounded-lg p-1.5 text-slate-400 transition hover:bg-green-50 hover:text-green-600 disabled:opacity-50"
          title="Helpful"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" />
          </svg>
        </button>
        <button
          onClick={() => handleFeedback(-1)}
          disabled={loading}
          className="rounded-lg p-1.5 text-slate-400 transition hover:bg-rose-50 hover:text-rose-600 disabled:opacity-50"
          title="Not helpful"
        >
          <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M10 15v4a3 3 0 003 3l4-9V2H5.72a2 2 0 00-2 1.7l-1.38 9a2 2 0 002 2.3H10z" />
          </svg>
        </button>
      </div>
      {showComment && (
        <div className="flex items-center gap-2">
          <input
            type="text"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="What went wrong?"
            className="rounded-lg border border-slate-200 px-2.5 py-1.5 text-xs outline-none focus:border-slate-400"
            onKeyDown={(e) => e.key === 'Enter' && handleDownvoteSubmit()}
          />
          <button
            onClick={handleDownvoteSubmit}
            disabled={loading}
            className="rounded-lg bg-slate-900 px-2.5 py-1.5 text-xs font-medium text-white transition hover:bg-slate-700 disabled:opacity-50"
          >
            Send
          </button>
          <button
            onClick={() => setShowComment(false)}
            className="rounded-lg px-2 py-1.5 text-xs text-slate-500 transition hover:bg-slate-100"
          >
            Cancel
          </button>
        </div>
      )}
    </div>
  )
}
